var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductPowerbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    role: "img",
    "aria-label": "Power bank",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    rx: 10,
    fill: "#F3EEFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 32,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#002454"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 48,
    width: 40,
    height: 24,
    rx: 4,
    fill: "#9e00ff",
    opacity: 0.85
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 54,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#fff",
    opacity: 0.45
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 54,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#fff",
    opacity: 0.45
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 54,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#fff",
    opacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 32 V24",
    stroke: "#002454",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 20,
    r: 4,
    fill: "#9e00ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPowerbank);
export default __webpack_public_path__ + "static/media/product-powerbank.77e0ad0ad6d0eb65f2c0a39e6002154a.svg";
export { ForwardRef as ReactComponent };